module.exports = __webpack_public_path__ + "img/mac_pc.b486cdae.png";